<template>
  <FlexColumn :space="3">
    <Label
      text="検索条件でフィルタリングします"
      size="body-2"
      class="mb-3 mt-n1"
      style="color: #aaa"
    />
    <ApplicantSearchConditionsSets @select="handleSelectConditionSet" />
    <ApplicantSearchKeywordsForm
        :andKeyword="andKeyword"
        :orKeyword="orKeyword"
        @input="handleKeyword"
    />
    <ApplicantSearchDataSelect
        v-model="data"
        :type="dataType"
        @input:type="value => dataType = value"
    />
    <ApplicantSearchPrefectureSelect
        v-model="currentPrefecture"
        label="現在の居住地"
    />
    <ApplicantSearchPrefectureSelect
        v-model="prefecture"
    />
    <ApplicantSearchPositionSelect
        v-model="position"
    />
    <ApplicantSearchSalarySelect
        v-model="salary"
    />
    <ApplicantSearchGenderSelect
        v-model="gender"
    />
    <ApplicantSearchAgeField
        v-model="age"
    />

    <FlexColumn space="half">
      <Label text="フィルタリング条件の追加" class="mb-2" bold />
      <FlexColumn :space="1">
        <ApplicantSearchCompetitionSelect v-model="medalist" class="mt-0" />
        <ApplicantSearchNewcomerSelect v-model="newcomer" class="mt-0" />
        <SwitchField name="スカウト送付可能のみ" v-model="scoutable" hide-details class="mt-0" />
      </FlexColumn>
    </FlexColumn>

    <FlexColumn>
      <TextButton primary @click="handleSearch">
        この条件で検索
      </TextButton>
      <TextButton outlined @click="handleSearchReset">
        <Label text="検索条件リセット" color="tertiary" :style="{flex: 1}" />
      </TextButton>
      <!-- todo: 右上の保存、上書きボタンだけで十分か要テスト、こっちのボタンが不要なら削除。 -->
      <!-- <FlexRow>
        <ApplicantSearchConditionsSaveButton
            :keyword="keyword"
            :keyword-type="keywordType"
            :data="data"
            :prefectures="prefecture"
            :positions="position"
            :salary="salary"
            :gender="gender"
            :age="age"
            :medalist="medalist"
            :newcomer="newcomer"
            :style="{flex: 1}"
        />
        <ApplicantSearchConditionSetUpdateButton
            v-if="selectedSearchConditionSet !== undefined"
            :keyword="keyword"
            :keyword-type="keywordType"
            :data="data"
            :prefectures="prefecture"
            :positions="position"
            :salary="salary"
            :gender="gender"
            :age="age"
            :medalist="medalist"
            :newcomer="newcomer"
        />
      </FlexRow> -->
    </FlexColumn>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import ApplicantSearchConditionsSets from "@/components/molecules/ApplicantSearchConditionsSets";
import ApplicantSearchKeywordsForm from "@/components/molecules/ApplicantSearchKeywordsForm";
import TextButton from "@/components/atoms/TextButton";
import ApplicantSearchDataSelect from "@/components/molecules/ApplicantSearchDataSelect";
import ApplicantSearchPrefectureSelect from "@/components/molecules/ApplicantSearchPrefectureSelect";
import ApplicantSearchPositionSelect from "@/components/molecules/ApplicantSearchPositionSelect";
import ApplicantSearchCompetitionSelect from "@/components/molecules/ApplicantSearchCompetitionSelect";
// import ApplicantSearchConditionsSaveButton from "@/components/molecules/ApplicantSearchConditionsSaveButton";
import ApplicantSearchAgeField from "../molecules/ApplicantSearchAgeField";
import ApplicantSearchGenderSelect from "../molecules/ApplicantSearchGenderSelect";
import ApplicantSearchSalarySelect from "../molecules/ApplicantSearchSalarySelect";
import ApplicantSearchNewcomerSelect from "../molecules/ApplicantSearchNewcomerSelect";
import Label from '../atoms/Label'
// import FlexRow from '../atoms/FlexRow'
import {mapActions, mapGetters} from "vuex";
import SwitchField from "../atoms/SwitchField.vue";
// import ApplicantSearchConditionSetUpdateButton from "./ApplicantSearchConditionSetUpdateButton";

export default {
  name: "ApplicantSearchForm",
  components: {
    SwitchField,
    // ApplicantSearchConditionSetUpdateButton,
    // FlexRow,
    ApplicantSearchNewcomerSelect,
    Label,
    ApplicantSearchSalarySelect,
    ApplicantSearchGenderSelect,
    ApplicantSearchAgeField,
    // ApplicantSearchConditionsSaveButton,
    ApplicantSearchCompetitionSelect,
    ApplicantSearchPositionSelect,
    ApplicantSearchPrefectureSelect,
    ApplicantSearchDataSelect,
    TextButton,
    ApplicantSearchKeywordsForm,
    ApplicantSearchConditionsSets,
    FlexColumn
  },
  data() {
    return {
      andKeyword: undefined,
      orKeyword: undefined,
      data: [],
      dataType: 'or',
      currentPrefecture: [],
      prefecture: [],
      position: [],
      salary: {
        lower: undefined,
        upper: undefined
      },
      gender: undefined,
      age: {
        lower: undefined,
        upper: undefined
      },
      medalist: false,
      newcomer: false,
      scoutable: false
    }
  },
  mounted() {
    this.setConditionsFromQuery()
  },
  beforeDestroy() {
    this.updateSelectedSearchConditionSet({conditionSet: undefined})
  },
  computed: {
    ...mapGetters("chatRequests", ["selectedSearchConditionSet"])
  },
  methods: {
    ...mapActions("chatRequests", ["updateSelectedSearchConditionSet"]),
    setConditionsFromQuery() {
      const conditions = this.$route.query
      this.andKeyword = conditions.andKeyword
      this.orKeyword = conditions.orKeyword
      this.data = this.toIntValues(conditions.data)
      this.dataType = conditions.dataType || 'or'
      this.currentPrefecture = this.toIntValues(conditions.currentPrefectures)
      this.prefecture = this.toIntValues(conditions.prefectures)
      this.position = this.toIntValues(conditions.position)
      this.salary = {
        lower: this.toIntValue(conditions.salaryLower),
        upper: this.toIntValue(conditions.salaryUpper)
      }
      this.gender = this.toIntValue(conditions.gender)
      this.age = {
        lower: this.toIntValue(conditions.ageLower),
        upper: this.toIntValue(conditions.ageUpper)
      }
      this.medalist = conditions.medalist === "true" || conditions.medalist === true
      this.newcomer = conditions.newcomer === "true" || conditions.newcomer === true
      this.scoutable = conditions.scoutable === "true" || conditions.scoutable === true
    },
    toIntValue(values) {
      if (values === undefined) {
        return undefined
      }
      if (typeof values === "string" && values.length > 0) {
        return parseInt(values)
      }
      if (typeof values === 'number') {
        return values
      }
      return undefined
    },
    toIntValues(values) {
      if (values === undefined) {
        return []
      }
      if (typeof values === "string") {
        return [parseInt(values)]
      }
      if (values instanceof Array) {
        return values.map(value => parseInt(value))
      }
      return []
    },
    handleKeyword(value) {
      this.andKeyword = value.andKeyword
      this.orKeyword = value.orKeyword
    },
    handleSelectConditionSet(conditionSet) {
      this.updateSelectedSearchConditionSet({conditionSet})
      const conditions = conditionSet.conditions
      this.andKeyword = conditions.andKeyword
      this.orKeyword = conditions.orKeyword
      this.data = conditions.data
      this.dataType = conditions.dataType
      this.currentPrefecture = conditions.currentPrefecture
      this.prefecture = conditions.prefecture
      this.position = conditions.position
      this.salary = {
        lower: conditions.salaryLower,
        upper: conditions.salaryUpper
      }
      this.gender = conditions.gender
      this.age = {
        lower: conditions.ageLower,
        upper: conditions.ageUpper
      }
      this.medalist = conditions.medalist
      this.newcomer = conditions.newcomer
      this.scoutable = conditions.scoutable
      this.handleSearch()
    },
    async handleSearch() {
      try {
        await this.$router.push({
          name: 'RequestsPage',
          params: {
            id: this.$route.params.id,
          },
          query: {
            andKeyword: this.andKeyword,
            orKeyword: this.orKeyword,
            data: this.data,
            dataType: this.dataType,
            currentPrefectures: this.currentPrefecture,
            prefectures: this.prefecture,
            position: this.position,
            medalist: this.medalist,
            salaryLower: this.salary.lower,
            salaryUpper: this.salary.upper,
            gender: this.gender,
            ageLower: this.age.lower,
            ageUpper: this.age.upper,
            newcomer: this.newcomer,
            scoutable: this.scoutable
          },
        })
      } catch (e) {
        if (e.name === "NavigationDuplicated") {
          this.$emit("research")
          return
        }
        throw e
      }
    },
    async handleSearchReset() {
      this.updateSelectedSearchConditionSet({conditionSet: undefined})
      await this.$router.push({
        name: 'RequestsPage',
        params: {
          id: this.$route.params.id,
        },
      })
    }
  },
  watch: {
    "$route": {
      handler() {
        this.setConditionsFromQuery()
      }
    }
  }
}
</script>

<style scoped>

</style>
